






import Vue from 'vue';
import { Partner } from '@/modules/kartoteka/partner';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { editMutations, actions } from '../../store/types';
import { store } from '../../store/edit';

export default Vue.extend({
	name: 'OzakazkaZakaznikSelect',
	components: { PartnerSelect: Partner.components.Select },
	props: {
		disabled: { type: Boolean, default: undefined },
		storeUri: { type: String, default: null },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${editMutations.OZAKAZKA_ZAKAZNIK_SELECT_MAPPER}`,
			};
		},
		actionsMapper(): Record<string, string> {
			return {
				actionName: `${this.storeUri}/${actions.ZAKAZNIK_CHANGE}`,
			};
		},
		oZakazkaFilter(): object {
			return {
				ZakaznikId: this.ZakaznikId,
				ZakaznikKonId: this.ZakaznikkonId,
				Ozakazka: true,
			};
		},
		ZakaznikText(): string | null {
			return this.ZakaznikId ? this.ZakaznikIdText : this.ZakaznikkonIdText;
		},
	},
});
